import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";

const GET_ACCESSORIES = `
	accessories (limit: $limit, page: $page, device_id: $device_id, type_id: $type_id, orderBy: $orderBy) {
		data {
			...Accessory
		}
		total
	}
`;

const ADD_ACCESSORY = `
	create_accessory (
		name: $name,
		code: $code,
		device_id: $device_id,
		properties: $properties,
		description: $description,
		warning_threshold: $warning_threshold,
		alert_threshold: $alert_threshold,
		type_id: $type_id,
		files: $files,
		maintain_hrs: $maintain_hrs,
		tag_ids: $tag_ids

	) {
    ...Accessory
	}
`;

const UPDATE_ACCESSORY = `
	update_accessory (
		id: $id,
		name: $name,
		code: $code,
		image_changed: $image_changed,
		properties: $properties,
		description: $description,
		warning_threshold: $warning_threshold,
		alert_threshold: $alert_threshold,
		is_reset_counter: $is_reset_counter,
		type_id: $type_id,
		files: $files,
		maintain_hrs: $maintain_hrs,
		tag_ids: $tag_ids


	) {
    ...Accessory
	}
`;

const DELETE_ACCESSORY = `
	delete_accessory (id: $id) {
		...Accessory
	}
`;

export default {
	init() {},

	fetchAccessories(payload) {
		const queryOptions = {
			query: gql`query Accessories ($limit: Int!, $page: Int!, $device_id: Int, $type_id: Int, $orderBy: OrderByObject) {
					${GET_ACCESSORIES}
				}
				${fragments.Accessory}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				device_id: payload.device_id || null,
				type_id: payload.type_id,
				orderBy: payload.orderBy || { column: "name", direction: "desc" }
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				accessories: response.data.accessories.data,
				total: response.data.accessories.total
			};
		});
	},

	addAccessory(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AccessoriesManagementCreateAccessory (
					$name: String!,
					$code: String,
					$device_id: Int!,
					$properties: String!,
					$description: String,
					$warning_threshold: Float,
					$alert_threshold: Float,
					$type_id: Int,
					$files: [Int],
					$maintain_hrs: Float,
					$tag_ids: [Int]

					) {
						${ADD_ACCESSORY}
					}
					${fragments.Accessory}
				`,
				variables: {
					name: payload.name,
					code: payload.code,
					device_id: payload.device_id,
					properties: payload.properties,
					description: payload.description,
					warning_threshold: payload.warning_threshold,
					alert_threshold: payload.alert_threshold,
					type_id: payload.type_id,
					files: payload.files || [],
					maintain_hrs: payload.maintain_hrs || 0,
					tag_ids: payload.tag_ids || []
				}
			})
			.then(response => response.data.create_accessory);
	},

	updateAccessory(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AccessoriesManagementUpdateAccessory (
					$id: Int!,
					$name: String!,
					$code: String,
					$image_changed: Boolean,
					$properties: String!,
					$description: String,
					$warning_threshold: Float,
					$alert_threshold: Float,
					$is_reset_counter: Boolean,
					$type_id: Int,
					$files: [Int],
					$maintain_hrs: Float,
					$tag_ids: [Int]
					) {
						${UPDATE_ACCESSORY}
					}
					${fragments.Accessory}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					code: payload.code,
					image_changed: !!payload.image_changed,
					properties: payload.properties,
					description: payload.description,
					warning_threshold: payload.warning_threshold,
					alert_threshold: payload.alert_threshold,
					is_reset_counter: payload.is_reset_counter || null,
					type_id: payload.type_id,
					files: payload.files || [],
					maintain_hrs: payload.maintain_hrs || 0,
					tag_ids: payload.tag_ids || []
				}
			})
			.then(response => response.data.update_accessory);
	},

	deleteAccessory(accessoryId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AccessoriesManagementDeleteAccessory ($id: Int!) {
					${DELETE_ACCESSORY}
				}
				${fragments.Accessory}
			`,
				variables: {
					id: accessoryId
				}
			})
			.then(response => response.delete_accessory);
	}
};
